




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { InsuranceUploadValue, InsuranceUploadErrors } from './types'
import {
  TypeSelect,
  MynaPortalDescription,
  InsuranceDescription,
  Uploader,
  Preview
} from './components'

@Component({
  components: {
    TypeSelect,
    MynaPortalDescription,
    InsuranceDescription,
    Uploader,
    Preview
  }
})
export default class InsuranceUploadForm extends Vue {
  @Prop({ required: true }) private value!: InsuranceUploadValue
  @Prop({ default: false }) private isConfirm!: boolean

  private localValue: InsuranceUploadValue = {
    imageType: '',
    firstImage: [],
    secondImage: []
  }

  private internalErrors: InsuranceUploadErrors = {}

  created() {
    this.localValue = { ...this.value }
  }

  @Emit('input')
  private update(val: InsuranceUploadValue) {
    return val
  }

  private onFilesChange(key: 'firstImage' | 'secondImage', file: File[]) {
    const checked = this.filterValidImage(file)
    console.log('checked', checked)
    if (!checked) return
    this.localValue = {
      ...this.localValue,
      [key]: file
    } as InsuranceUploadValue
    console.log('localValue', this.localValue)
    this.update(this.localValue)
  }

  private filterValidImage(file: File[]): boolean {
    // 合計サイズ 15MB 超は切り捨て
    const limit = 15 * 1024 * 1024
    return file.every(f => f.size <= limit)
  }

  public validate(): boolean {
    this.internalErrors = {
      firstImage: '',
      secondImage: ''
    }
    if (this.localValue.imageType === 'insurance') {
      if (this.localValue.firstImage.length === 0) {
        this.internalErrors.firstImage = '1枚目の画像を追加してください'
      }
      if (this.localValue.secondImage.length === 0) {
        this.internalErrors.secondImage = '2枚目の画像を追加してください'
      }
    } else {
      if (this.localValue.firstImage.length === 0) {
        this.internalErrors.firstImage = '1枚目の画像を追加してください'
      }
    }
    return (
      !this.internalErrors.imageType &&
      !this.internalErrors.firstImage &&
      !this.internalErrors.secondImage
    )
  }

  public getValue(): InsuranceUploadValue {
    return { ...this.localValue }
  }

  public getErrors(): InsuranceUploadErrors {
    return { ...this.internalErrors }
  }
}
